import React from 'react';
import PropTypes from 'prop-types';

import Footer from '../../../Footer/Footer';
import Toaster from '../../../Toaster/Toaster';
import StoreHeader from '../StoreHeader/StoreHeader';
import SocketContext from '../../../SocketContext';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    return (
      <SocketContext.Consumer>
        {
          socket => (
            <div className={'store'}>
              <Toaster />
              <StoreHeader />
              {this.props.children}
              <Footer />
            </div>
          )
        }
      </SocketContext.Consumer>
    );
  }
};

export default Layout;
